/* eslint-disable no-param-reassign */
/* global G */
import { _update, _get } from '@platform/adapter/settings/helper/settings'
import { date, sortBy, uniqueBy } from 'lib/util/array'

/**
 * Updates the remote document with the adapters local `G.STATE` and `G.DATA`.
 *
 * Dispatches `G.SETTINGS, G.DONE` event afterward.
 *
 * @param {Gaia.Web.Application} app  the Platform Web Application
 * @returns {(function(): Promise<boolean>)|*}
 */
const fn = app => async () => {
  const eventBus = app[G.ADAPTER][G.EVENTS]
  const adapter = app[G.ADAPTER][G.SETTINGS]
  const { status, ...data } = adapter[G.DATA]
  const { refs } = adapter[G.STATE]
  const state = adapter[G.STATE]

  const { [G.API]: api, _rev, key } = state

  try {
    const isLogged = !!app[G.SESSION][G.STATE][G.META]

    if (!isLogged) {
      throw new Error('Could not update user settings. No session.')
    }

    // Updating the userSettings document
    const response = await _update(app, { api, _rev, key, data: { value: data, refs } })

    if (response.ok) {
      // Saving the new rev
      adapter[G.API].change({ detail: { [G.DATA]: { _rev: response.rev } } })

      eventBus.dispatch(eventBus.type(G.SETTINGS, G.DONE))

      return true
    }
  } catch (e) {
    if (e?.code === 409) {
      const { _rev: newRev, value: { status: _, ...serverData } } = await _get(app, { api, key })
      const mergedData = {
        ...serverData,
        ...data,
        favorites: uniqueBy(data.favorites.concat(serverData.favorites)),
        recents: sortBy(uniqueBy(data.recents.concat(serverData.recents), 'timestamp'), date('timestamp')),
      }

      adapter[G.DATA] = { ...adapter[G.DATA], ...mergedData }
      adapter[G.STATE]._rev = newRev

      fn(app)() // calling this function again
    } else {
      console.error(e)
    }
  }

  return false
}

export default fn
